export default "__VITE_ASSET__DdMI7jy4__"